export const MAX_ANNOTATION_SYMBOL = 32_000;
